import React from 'react';

import { TableCell, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { isSameDay, prettyDateTime, toCapitalize } from '../../../lib/helpers/helpers';
import { Check, Close } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  tableRow: theme.globalClasses.adminTableRowWrapper,
}));

const PatientCheckInHistoryRow = ({ row }) => {
  const classes = useStyles();
  const { cached_day_progress } = row;
  const chosenRow = cached_day_progress
    ? cached_day_progress.filter((item) => isSameDay(item.day_start, row.createdAt))[0]
    : [];
  return (
    <TableRow
      tabIndex={-1}
      id={row.id}
      key={row.id}
      className={classes.tableRow}
    >
      <TableCell align="left">{prettyDateTime(row.createdAt)}</TableCell>
      <TableCell align="left">{row.challenge ? row.challenge.name : 'N/A'}</TableCell>
      <TableCell align="left">{chosenRow ? chosenRow.day : 'N/A'}</TableCell>
      <TableCell align="left">{row.feeling ? toCapitalize(row.feeling) : 'N/A'}</TableCell>
      <TableCell align="left">{row.mealType ? toCapitalize(row.mealType) : 'N/A'}</TableCell>
      <TableCell align="left">{chosenRow ? chosenRow.has_checkin ? <Check /> : <Close /> : 'N/A'}</TableCell>
      <TableCell align="left">{row.paused ? row.paused ? <Check /> : <Close /> : 'N/A'}</TableCell>
      <TableCell align="left">{chosenRow ? chosenRow.success ? <Check /> : <Close /> : 'N/A'}</TableCell>
      <TableCell align="left">{row.notes ?? 'N/A'}</TableCell>
    </TableRow>
  );
};

export default PatientCheckInHistoryRow;
